import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PageState } from '../models/page.model';

export const selectMenuState = createFeatureSelector<PageState>('page');

export const getMenuItems = createSelector(
  selectMenuState,
  (state: PageState) => state.menu_items
);

export const getBannerComponent = createSelector(
  selectMenuState,
  (state: PageState) => state.banner_component
);

export const getBannerSubtitle = createSelector(
  selectMenuState,
  (state: PageState) => state.banner_subtitle
);
